export interface FileUploadI {
  nome: string;
  base64: string;
  contentType: string;
}

export const MIN_DIMENSION = 150;
export const MAX_UPLOAD_SIZE = 1024 * 1024 * 3; // 3MB
